import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { ghostButtonClass, Status } from "../components/ui";
import { getRole } from "../lib/auth";
import { ScheduleCalendar } from "../schedule/ScheduleCalendar";
import { usePDDays } from "../pddays/usePDDays";

export function Schedule() {
  const { t } = useTranslation();
  const { all, total, loading, error } = usePDDays();

  const back = getRole() !== "teacher" && (
    <NavLink to="/pd-days" className={`${ghostButtonClass} mb-4`}>
      <ChevronLeft size={16} />
      {t("backToPDDays")}
    </NavLink>
  );

  if (loading) {
    return <Status variant="loading" title={t("loading")} message={t("loadingPDDays")} />;
  }
  if (error) {
    return (
      <>
        {back}
        <Status variant="error" title={t("pdDaysUnavailable")} message={error} />
      </>
    );
  }

  return (
    <div className="flex flex-col gap-4 pb-6">
      {back}
      <div className="flex flex-col">
        <h1 className="text-2xl font-bold tracking-tight text-app-ink">{t("navSchedule")}</h1>
        <p className="mt-0.5 text-sm text-app-muted">{t("scheduleHelp")}</p>
      </div>
      {total === 0 ? (
        <Status variant="empty" title={t("noAssignedPDDay")} message={t("noAssignedPDDayHelp")} />
      ) : (
        <ScheduleCalendar days={all} />
      )}
    </div>
  );
}
